<template>
  <helper-layout :loaded="mx_loaded">
    <material-table
      :search-data="searchData"
      :headers="headers"
      :items="items"
      :paginate="paginateConfig"
      :total-count="paginateConfig.total"
      @pageChange="handlePageChange"
      @searchChange="handleSearchChange"
    />
  </helper-layout>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import { pageLoadMx } from '@/plugins/mixins'
import { startOfMonth, format } from 'date-fns'
// import TOOL from '@/utils/tool'
const STARTMONTH = format(startOfMonth(new Date()), 'YYYY-MM-DD')
const NOWMONTH = format(new Date(), 'YYYY-MM-DD')

export default {
  mixins: [pageLoadMx],
  data() {
    const $t = this.$t.bind(this)
    return {
      headers: [],
      items: [],
      searchData: [
        {
          key: 'dateRange',
          label: $t('Views.Order.orderTime'),
          type: 'daterange',
          icon: 'mdi-calendar',
          maxDate: new Date().toISOString(),
          value: {
            start: STARTMONTH,
            end: NOWMONTH
          },
          config: {
            clearable: false,
            rangeClose: true
          },
          default: {
            start: STARTMONTH,
            end: NOWMONTH
          }
        },
        {
          key: 'productCategoryId',
          id: '',
          value: '',
          // 分类
          label: $t('Views.Goods.categoryName'),
          type: 'cascader',
          placeholder: $t('Views.Goods.please'),
          config: {
            label: 'name',
            value: 'id',
            children: 'items',
            checkStrictly: true
          },
          state: []
        }
      ],
      paginateConfig: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      form: {
        startTime: STARTMONTH,
        endTime: NOWMONTH,
        productCategoryId: '',
        skipCount: 0,
        maxResultCount: 10
      }
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    },
    ...mapState('report', ['reportData']),
    ...mapState('goods', ['categoryList']),
    ...mapState('app', ['color', 'disableColor'])
  },
  mounted() {
    this.getCategory()
    setTimeout(() => {
      this.getPage()
    }, 0)
  },
  methods: {
    ...mapActions('goods', ['getCategoryList']),
    ...mapActions('report', ['getReportData']),
    getPage(page) {
      if (typeof page !== 'undefined') {
        this.paginateConfig.page = page
        this.form.skipCount = (page - 1) * this.form.maxResultCount
      }
      if (!this.mx_loaded) this.mx_loading_fn() // 页面加载中
      this.getReportData(this.form).then(() => {
        this.paginateConfig.total = this.reportData.dataRows.totalCount
        this.items = this.reportData.dataRows.items

        if (this.headers.length < 1) {
          let headers = Object.assign([], this.headers)
          const columns = this.reportData.columns
          headers = Object.keys(columns).map(key => {
            const ret = {
              text: columns[key],
              value: key,
              prefix: key === 'priceAndTaxAmout' || key === 'price' ? '¥ ' : ''
            }

            return ret
          })

          this.headers = headers
        }

        this.mx_loaded_fn() // 页面加载完成
      })
    },
    getCategory() {
      this.getCategoryList().then(() => {
        this.searchData[1].state = this.categoryList
      })
    },
    handleSearchChange(search) {
      this.form = { ...this.form, ...search }

      if (search.dateRange) {
        this.form = {
          ...this.form,
          startTime: search.dateRange.start,
          endTime: search.dateRange.end
        }
      }
      delete this.form.dateRange
      this.getPage(1)
    },
    handlePageChange(page) {
      this.getPage(page)
    }
  }
}
</script>
<style scoped></style>
